import { now } from "lodash";
import React, { FC, useState, memo, useEffect } from "../../../lib/teact/teact";
import Avatar from "../../common/Avatar";
import Button from "../../ui/Button";
import Checkbox from "../../ui/Checkbox";
import ConfirmDialog from "../../ui/ConfirmDialog";
import DropdownMenu from "../../ui/DropdownMenu";
import FloatingActionButton from "../../ui/FloatingActionButton";
import InputText from "../../ui/InputText";
import MenuItem from "../../ui/MenuItem";
import ThongKeDBMienBac from "../bettools/ThongKeDBMienBac";
import { LotScreenSettings } from "../config/uiconfig";
import { ParseAndSaveMessageLocal } from "../db/service/parserService";
import { updateLastScreen } from "../redux/loginSlice";
import { CanChuyen } from "../restapi/canChuyen";
import Parser from "../restapi/parser";
import worker from "../setupWorker";
import store from "../store";
import { LotMessage } from "../types/types";
import LotSpinner from "../ui/LotSpinner";
import '../ui/formCommon.scss'
import { addDays, getCurDate, getCurrentTime, getDateString, getDateStringVN } from "../utils/DateTimeUtils";
import { IsBetToolEnable, isLocalMode } from "../utils/common";
import MessageEditor from "./messageEditor";
import MyTextInput from "../ui/myTextInput";
import { re } from "mathjs";



type OwerProps = {

    onUpdate: (html: string) => void;
    onChangeScreen: (screen: LotScreenSettings) => void;
    backToScreen: LotScreenSettings;
    showHeader?: boolean;
    messages?: LotMessage[];
    messageIndex: number;
    onTextChange?: (htmlText: string, rawText: string) => void;
    htmlError?: string,
    errorText?: string,

}

const NhapTinNhan: FC<OwerProps> = ({
    onUpdate,
    onChangeScreen,
    backToScreen,
    showHeader,
    messages,
    messageIndex,
    onTextChange,
    htmlError,
    errorText,


}) => {
    const editingMessage: any = store.getState().global.editingMessage;
    const msg = (messages && messages.length > 0) ? messages[messageIndex] : undefined
    const html = (messages && messages.length > 0) ? messages[messageIndex].body : ""
    const [rawText, setRawText] = useState(html)
    const curContact: any = store.getState().contact.currentContact
    let contactId = "msgType";
    if (curContact)
        contactId = curContact!.contactId!
    let tmpType = localStorage[contactId]
    if (tmpType == undefined) {
        localStorage[contactId] = 1
        tmpType = 1
    }
    const [state, setState] = useState({
        rawText: html,
        html: html,
        htmlError: htmlError != undefined ? htmlError : html,
        errorText: errorText != undefined ? errorText : "",
        isSaving: false,
        msgType: Number(localStorage[contactId]),
        message: msg,
        showGetTicketDialog: false,
        showThongKeDialog: false,
        showThongKeKhachChoiDialog: false,
        tuNgay: addDays(store.getState().global.workDate, 0),
        denNgay: addDays(store.getState().global.workDate, 0),
        laySoRaNhieu: false,
        showGan: true,
        soNgayGan: 5,
        soBoSo: 25,
        muc1: 300,
        muc2: 400,
        muc3: 500,
        giai7: [] as any[],
        parserCalledTime: now().toString(),
    })
    //Lưu lại màn hình này, nếu vào trong sẽ quay lại đây
    useEffect(() => {
        store.dispatch(updateLastScreen(LotScreenSettings.NHAP_TIN_NHAN_SCREEN))
        // nếu là edit tin nhắn thì load data ở đây

        if (editingMessage != undefined) {
            const lotMsg: LotMessage = {

                body: editingMessage.body,

            }
            setState(prev => ({
                ...prev, message: lotMsg,
                html: lotMsg.body,
                htmlError: lotMsg.body,
                rawText: lotMsg.body,
            }))
            console.log(state)

        }
    }, [])
    useEffect(() => {
        // Chỉ đồng bộ theo props messages khi component đang ở chế độ duyệt danh sách tin.
        // Với màn hình edit đơn lẻ (dùng editingMessage từ store), không được ghi đè thành rỗng.
        if (!messages) {
            return;
        }
        setState(prev => ({
            ...prev,
            message: msg,
            html: html,
            rawText: html,
            ...(msg ? {} : { htmlError: "", errorText: "", parserCalledTime: now().toString() }),
        }))
    }, [messages, msg, html])
    useEffect(() => {
        setState((prev: any) => ({
            ...prev, htmlError: htmlError != undefined ? htmlError : "",
            errorText: errorText != undefined ? errorText : ""
        }))
    }, [htmlError, errorText])
    function handleTextChange(htmlText: string, rawText: string) {
        setState(prev => ({ ...prev, html: htmlText, rawText: rawText }))
        if (onTextChange)
            onTextChange(htmlText, rawText);
    }
    function handleMsgTypeChange(type: any) {
        setState(prev => ({ ...prev, msgType: Number(type) }))
        localStorage[contactId] = type
    }
    function parseMessage() {
        const ct: any = store.getState().contact.currentContact
        const mienId = store.getState().basicReport.mienDaiCuocId
        let mien = "NAM"
        switch (Number(mienId)) {
            case 1:
                mien = "BAC"
                break;
            case 2:
                mien = "TRUNG"
                break;
        }
        //
        let tmpElement = document.createElement("div")
        let tmp = state.html.replace(/<div>/g, '<br><div>')
        tmp = tmp.replace(/<br>/g, '\n')
        // Thay thế tất cả các thẻ <p> bằng thẻ <div> bằng regex
        tmp = tmp.replace(/<p\b[^>]*>/g, '<div>').replace(/<\/p>/g, '</div>\n');
        tmpElement.innerHTML = tmp
        let textContent = tmpElement.innerText
        if (textContent == '') {
            textContent = state.rawText;
        }
        let lock = 0;
        if (store.getState().basicReport.mienDaiCuocId != 0)
            lock = 1
        //
        const body = {
            body: textContent,
            date: store.getState().global.workDate,
            time: getCurrentTime(),
            type: state.msgType,
            contactId: ct!.contactId,
            curMien: mien,
            getCompactData: 1,
            getRawData: 0,
            lockArea: lock,
            editedMessageId: editingMessage ? editingMessage.messageId : 0,

        }
        if (textContent.trim() == "") {
            setState(prev => ({
                ...prev, errorText: "Nội dung tin không để trống",
                htmlError: ""
            }))
            return;
        }
        setState(prev => ({ ...state, isSaving: true }))
        if (!isLocalMode()) {
            Parser.parseMessage(body).then(result => {
                setState(prev => ({ ...prev, isSaving: false }))
                let msgBody = result.data.html
                let msgTextNotify = result.responseText
                //let msgTextNotify = result.data.responseText
                if (result.data.parseStatus == "parseOK") {
                    msgTextNotify = result.data.responseText
                    onChangeScreen(backToScreen)
                }
                if (msgBody == "")
                    msgBody = result.data.bodyViet
                //if (result.errorCode!=0){
                setState(prev => ({
                    ...prev, errorText: msgTextNotify,
                    htmlError: msgBody, parserCalledTime: now().toString()
                }))
                //}
            })
        }
        else {
            ParseAndSaveMessageLocal(body as LotMessage).then(result => {
                setState(prev => ({ ...state, isSaving: false }))
                setState(prev => ({ ...state, isSaving: false }))
                let msgBody = result.data.html
                let msgTextNotify = result.responseText + result.data.totalErrorText
                //let msgTextNotify = result.data.responseText
                if (result.data.parseStatus == "parseOK") {
                    msgTextNotify = result.responseText
                    onChangeScreen(backToScreen)
                }
                if (msgBody == "")
                    msgBody = result.data.bodyViet
                //if (result.errorCode!=0){
                setState(prev => ({
                    ...prev, errorText: msgTextNotify,
                    htmlError: msgBody
                }))
                //}
            })

        }
    }
    useEffect(() => {
        if (state.showGetTicketDialog) {
            const payload = { ngay: store.getState().global.workDate }
            CanChuyen.getKQTTMB(payload).then(res => {
                if (res && res.data) {
                    const giais = ["7.1", "7.2", "7.3", "7.4"]
                    const giai7: any[] = res.data.filter((giai: any) => {
                        const found = giais.includes(giai.tengiai)
                        return found
                    })
                    const giai7Sorted = giai7.sort((a: any, b: any) => {
                        if (a.tengiai < b.tengiai) return -1;
                        if (a.tengiai > b.tengiai) return 1;
                        return 0;
                    });
                    setState(prev => ({ ...prev, giai7: giai7Sorted }))
                }
            })
        }
    }, [state.showGetTicketDialog])
    function handleSettingsOnClick() {
        setState(prev => ({ ...prev, showGetTicketDialog: true }))

    }
    function handleThongKeDbMbOnClick() {
        setState(prev => ({ ...prev, showThongKeDialog: true }))

    }
    function handleThongKeDbMbKhachChoiOnClick() {
        setState(prev => ({ ...prev, showThongKeKhachChoiDialog: true }))

    }
    function handleOnShowTicketDialogConfirm() {
        setState(prev => ({ ...prev, showGetTicketDialog: false }))
        console.log('handleSettingsOnClick')
        const payload = { ngay: store.getState().global.workDate, muc1: state.muc1, muc2: state.muc2, muc3: state.muc3 }
        CanChuyen.getTicketMB(payload).then(res => {
            console.log(res)
            if (res.data.sms != "") {
                setState(prev => ({
                    ...prev, html: res.data.sms, rawText: res.data.sms,
                    htmlError: res.data.sms
                }))
            }
        })
    }
    function handleOnShowThongKeConfirm() {
        setState(prev => ({ ...prev, showThongKeDialog: false }))
        if (state.laySoRaNhieu) {
            CanChuyen.getThongKeDbMbRaNhieu({ ngay: state.tuNgay, denNgay: state.denNgay }).then(res => {
                console.log(res)
                if (res.data) {
                    let sms = ""
                    res.data.map((item: any) => {
                        sms += sms == '' ? item.thuocTinh + "\n" : ' va ' + item.thuocTinh + "\n";
                    })
                    sms = 'de ' + sms + ' 1n';
                    setState(prev => ({
                        ...prev, html: sms, rawText: sms,
                        htmlError: sms
                    }))
                }
            })
        } else {
            CanChuyen.getThongKeDbMb({ ngay: state.tuNgay, denNgay: state.denNgay }).then(res => {
                console.log(res)
                function countComma(s: string) {
                    return (s.match(/,/g) || []).length;
                }
                if (res.data) {
                    let sms = ""
                    let sorted = res.data.sort((a: any, b: any) => {
                        return b.soNgayGan - a.soNgayGan
                    })
                    sorted.map((item: any) => {
                        let count = countComma(item.daySo) + 1
                        let showGan = (state.showGan ? ` (gan: ${item.soNgayGan} ngày - ${count} số )` : "")

                        if (count >= state.soBoSo) {
                            if (state.soNgayGan > 0) {
                                if (item.soNgayGan >= state.soNgayGan) {
                                    sms += sms == '' ? item.thuocTinh + showGan + "\n" : ' va ' + item.thuocTinh +
                                        showGan +
                                        "\n";
                                }
                            } else {
                                sms += sms == '' ? item.thuocTinh + showGan + "\n" : ' va ' + item.thuocTinh +
                                    showGan +
                                    "\n";
                            }
                        }
                    })
                    if (!state.showGan)
                        sms = 'de 100 so bor ' + sms + ' 1n'
                    setState(prev => ({
                        ...prev, html: sms, rawText: sms,
                        htmlError: sms
                    }))
                } else {
                    setState(prev => ({
                        ...prev, html: "", rawText: "",
                        htmlError: ""
                    }))
                }
            })
        }

    }
    function handleThongKeClose() {
        setState(prev => ({ ...prev, showThongKeKhachChoiDialog: false }))
    }
    function handleOnThongKeKhachChoiConfirm(text: string) {
        let sms: string = text
        setState(prev => ({
            ...prev, html: prev.html + '\n' + sms, rawText: sms,
            htmlError: prev.htmlError + '\n' + sms
        }))
    }
    function handleBuildDbMb() {
        const payload = { ngay: state.denNgay }
        CanChuyen.insertThuocTinhDacBiet(payload).then(res => {
            if (res && res.responseText) {
                worker.postMessage({ type: 'showsnackbar', data: res.responseText })
            }
        });
    }
    return (
        <div className="form-main">
            {showHeader &&
                <div className="form-header">
                    <div className="form-header left-panel">
                        <Button
                            round
                            size="default"
                            color="translucent"
                            onClick={() => {
                                onChangeScreen(backToScreen)
                            }}
                        //className={buildClassName(styles.headerButton, styles.firstButton)}
                        //ariaLabel={lang(isFullscreen ? 'AccExitFullscreen' : 'AccSwitchToFullscreen')}
                        >
                            <i
                                className='icon icon-arrow-left'
                                aria-hidden
                            />
                        </Button>
                        <Avatar
                            //photo={notPersonalPhoto}
                            noPersonalPhoto
                            //peer={user}
                            text={curContact ? curContact.name : ""}
                            size="small"
                            className="personal-photo"
                        />
                        <div>{curContact ? curContact.name : ""}</div>
                    </div>
                    <div className="form-header right-panel">
                        {
                            !state.isSaving &&
                            <Button round
                                size="default"
                                color="translucent"
                                onClick={parseMessage}>
                                <i className="fa-regular fa-floppy-disk fa-beat fa-xl"></i>

                            </Button>
                        }
                        {
                            state.isSaving && <div style="padding:0 0.75rem 0 0"

                            > <LotSpinner /> </div>
                        }
                        <DropdownMenu positionX="right">
                            <MenuItem icon="settings"
                                onClick={handleSettingsOnClick}>
                                Cài đặt
                            </MenuItem>
                            {
                                IsBetToolEnable() &&
                                <MenuItem icon="settings"
                                    onClick={handleThongKeDbMbOnClick}>
                                    Thống kê ĐB MB
                                </MenuItem>
                            }
                            {
                                IsBetToolEnable() &&
                                <MenuItem icon="settings"
                                    onClick={handleThongKeDbMbKhachChoiOnClick}>
                                    Thống kê khách chơi ĐB MB
                                </MenuItem>
                            }
                        </DropdownMenu>
                    </div>
                </div>
            }
            <div className="form-content">
                <MessageEditor
                    htmlError={state.htmlError}
                    errorTextToUser={state.errorText}
                    triggerTime={state.parserCalledTime}
                    onTextChange={handleTextChange}
                    onMsgTypeChange={handleMsgTypeChange}
                    msgType={state.msgType}
                    showHeader={showHeader}
                    message={state.message}
                    maxHeight={showHeader ? undefined : '25vh'}
                    showSearchButton
                    lockBaMien
                ></MessageEditor>
            </div>
            <ConfirmDialog
                title="Ticket params"
                isOpen={state.showGetTicketDialog}
                confirmHandler={handleOnShowTicketDialogConfirm}
                onClose={() => setState(prev => ({ ...prev, showGetTicketDialog: false }))}
            >
                <InputText label="mức 1" value={state.muc1}
                    onChange={(e) => {
                        const val = e.target.value;
                        const n = Number(val)
                        if (!isNaN(n)) {
                            setState(prev => ({ ...prev, muc1: n }))
                        }
                    }}></InputText>
                <InputText label="mức 2" value={state.muc2}
                    onChange={(e) => {
                        const val = e.target.value;
                        const n = Number(val)
                        if (!isNaN(n)) {
                            setState(prev => ({ ...prev, muc2: n }))
                        }
                    }}
                ></InputText>
                <InputText label="mức 3" value={state.muc3}
                    onChange={(e) => {
                        const val = e.target.value;
                        const n = Number(val)
                        if (!isNaN(n)) {
                            setState(prev => ({ ...prev, muc3: n }))
                        }
                    }}
                ></InputText>
                <div className=" common-container-row">
                    {
                        state.giai7.map((giai: any) => {
                            return <div>{giai.sodaydu}</div>
                        })
                    }
                </div>
            </ConfirmDialog>
            <ConfirmDialog
                title="Thống kê ĐB MB"
                isOpen={state.showThongKeDialog}
                confirmHandler={handleOnShowThongKeConfirm}
                onClose={() => setState(prev => ({ ...prev, showThongKeDialog: false }))}
            >
                <div className="kqxs-dialog-main row">
                    <div>Từ ngày</div>
                    <input type='date' value={state.tuNgay} className="date-input"
                        onChange={(e) => {
                            setState(prev => ({ ...prev, tuNgay: e.target.value }))
                        }}
                    />
                </div>
                <div className="kqxs-dialog-main row">
                    <div>Đến ngày</div>
                    <input type='date' value={state.denNgay} className="date-input"
                        onChange={(e) => {
                            setState(prev => ({ ...prev, denNgay: e.target.value }))
                        }}
                    />
                </div>
                <div className="kqxs-dialog-main row">
                    <Checkbox label='Số ra nhiều' checked={state.laySoRaNhieu}
                        onChange={(e) => {
                            setState(prev => ({ ...prev, laySoRaNhieu: e.target.checked }))
                        }}
                    ></Checkbox>

                </div>
                <div className="kqxs-dialog-main row">
                    <Checkbox label='Số ngày gan' checked={state.showGan}
                        onChange={(e) => {
                            setState(prev => ({ ...prev, showGan: e.target.checked }))
                        }}
                    ></Checkbox>
                    <MyTextInput label="" value={state.soNgayGan} onChange={(e) => {
                        setState(prev => ({ ...prev, soNgayGan: Number(e.target.value) }))
                    }}></MyTextInput>
                </div>
                <div className="kqxs-dialog-main row">

                    <MyTextInput label="số bộ số tối thiểu" value={state.soBoSo} onChange={(e) => {
                        setState(prev => ({ ...prev, soBoSo: Number(e.target.value) }))
                    }}></MyTextInput>
                </div>
                <div><Button onClick={handleBuildDbMb}>Build ĐBMB</Button></div>
            </ConfirmDialog>
            <ThongKeDBMienBac
                isOpen={state.showThongKeKhachChoiDialog}
                onClose={handleThongKeClose}
                onConfirm={handleOnThongKeKhachChoiConfirm}
            ></ThongKeDBMienBac>
        </div>
    )
}

export default memo(NhapTinNhan)